import { PayloadAction } from '@reduxjs/toolkit';
import { ShipmentBundle } from 'api/optimalprint-sdk.d';
import { ProductState } from 'store/product/types';

const setDeliveryOptionsReducer = (
  state: ProductState,
  action: PayloadAction<ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListDetailedV2Response.IShipmentDetails>,
) => {
  state.deliveryOptions = action.payload;
};

export default setDeliveryOptionsReducer;
